import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import cnIcon1 from '../../../images/icons/icon_php.svg'
import cnIcon2 from '../../../images/icons/icon_javascript.svg'
import cnIcon3 from '../../../images/case/icon_elephent.svg'
import cnIcon4 from '../../../images/icons/icon_swift.svg'
import cnIcon5 from '../../../images/icons/icon_typescript.svg'
import cnIcon6 from '../../../images/icons/icon_python.svg'
import cnIcon7 from '../../../images/icons/icon_g318.svg'
import cnIcon8 from '../../../images/icons/icon_java.svg'
import cnIcon9 from '../../../images/icons/icon_ruby.svg'
import cnIcon10 from '../../../images/icons/icon_c_plus.svg'
import cnIcon11 from '../../../images/icons/icon_react_js.svg'
import cnIcon12 from '../../../images/icons/icon_laravel.svg'
import Bg from '../../../images/shapes/shape_title_under_line.svg'

import aiOpenai from '../../../images/clients/buildlab_openai.svg'
import aiAnthropic from '../../../images/clients/buildlab_anthropic.svg'
import aiGoogle from '../../../images/clients/buildlab_google.svg'
import aiMicrosoft from '../../../images/clients/buildlab_microsoft.svg'
import aiAws from '../../../images/clients/buildlab_aws.svg'
import aiIbm from '../../../images/clients/buildlab_ibm.svg'
import aiSalesforce from '../../../images/clients/buildlab_salesforce.svg'
import aiAdobe from '../../../images/clients/buildlab_adobe.png'


const TechnologyList = [
    { Id: '1', sIcon: cnIcon1, title: 'PHP' },
    { Id: '2', sIcon: cnIcon2, title: 'JavaScript' },
    { Id: '3', sIcon: cnIcon3, title: 'PostgreSQL' },
    { Id: '4', sIcon: cnIcon4, title: 'Swift' },
    { Id: '5', sIcon: cnIcon5, title: 'Typescript' },
    { Id: '6', sIcon: cnIcon6, title: 'Python' },
    { Id: '7', sIcon: cnIcon7, title: 'G318' },
    { Id: '8', sIcon: cnIcon8, title: 'Java' },
    { Id: '9', sIcon: cnIcon9, title: 'Ruby' },
    { Id: '10', sIcon: cnIcon10, title: 'C++' },
    { Id: '11', sIcon: cnIcon11, title: 'React Js' },
    { Id: '12', sIcon: cnIcon12, title: 'Laraval' },
]

const AI_TABS = [
    {
        label: 'LLMs & Foundation Models',
        items: [
            { icon: aiOpenai, title: 'OpenAI · GPT' },
            { icon: aiAnthropic, title: 'Anthropic · Claude' },
            { icon: aiGoogle, title: 'Google · Gemini' },
            { icon: aiMicrosoft, title: 'Azure OpenAI' },
            { icon: aiAws, title: 'AWS Bedrock' },
            { icon: aiIbm, title: 'IBM watsonx' },
        ],
    },
    {
        label: 'AI Assistants & Copilots',
        items: [
            { icon: aiMicrosoft, title: 'Microsoft 365 Copilot' },
            { icon: aiOpenai, title: 'ChatGPT Business' },
            { icon: aiAnthropic, title: 'Claude for Work' },
            { icon: aiGoogle, title: 'Gemini for Workspace' },
            { icon: aiAdobe, title: 'Adobe Firefly' },
        ],
    },
    {
        label: 'Enterprise & Custom AI',
        items: [
            { icon: aiSalesforce, title: 'Salesforce Einstein' },
            { icon: aiMicrosoft, title: 'Azure AI Studio' },
            { icon: aiAws, title: 'AWS Bedrock & SageMaker' },
            { icon: aiIbm, title: 'IBM watsonx' },
            { icon: aiOpenai, title: 'Custom GPTs & APIs' },
            { icon: aiAnthropic, title: 'Claude API' },
        ],
    },
]


const TechnologySection = ({ aiMode } = {}) => {

    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    if (aiMode) {
        return (
            <div className="section_space">
                <div className="heading_block text-center">
                    <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                        Our AI Stack
                    </div>
                    <h2 className="heading_text mb-0">
                        AI Tools We <mark>Work With</mark>
                    </h2>
                </div>

                <div className="tab_block_wrapper">
                    <Nav tabs className="nav justify-content-center">
                        {AI_TABS.map((t, i) => (
                            <NavItem key={i}>
                                <NavLink
                                    className={classnames({ active: activeTab === String(i + 1) })}
                                    onClick={() => toggle(String(i + 1))}
                                >
                                    {t.label}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        {AI_TABS.map((t, i) => (
                            <TabPane tabId={String(i + 1)} key={i}>
                                <div className="web_development_technologies row justify-content-center">
                                    {t.items.map((item, j) => (
                                        <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={j}>
                                            <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                                <div className="iconbox_icon" style={{ height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img src={item.icon} alt={item.title} style={{ maxHeight: 44, maxWidth: '80%', objectFit: 'contain' }} />
                                                </div>
                                                <div className="iconbox_content">
                                                    <h3 className="iconbox_title mb-0" style={{ fontSize: '.85rem' }}>{item.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </TabPane>
                        ))}
                    </TabContent>
                </div>
            </div>
        )
    }

    return (

        <div className="section_space">
            <div className="heading_block text-center">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                    Our Technologies
                </div>
                <h2 className="heading_text mb-0">
                    We Use <mark>Technologies</mark>
                </h2>
            </div>

            <div className="tab_block_wrapper">
                <Nav tabs className="nav justify-content-center">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => { toggle('1'); }}
                        >
                            Web Platform
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => { toggle('2'); }}
                        >

                            Databases
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => { toggle('3'); }}
                        >

                            Cloud & DevOps
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '4' })}
                            onClick={() => { toggle('4'); }}
                        >

                            Mobile Apps
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '5' })}
                            onClick={() => { toggle('5'); }}
                        >

                            Other Frameworks
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(0, 12).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="2">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(3, 12).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(5, 12).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="4">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(1, 12).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="5">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(3, 10).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    )
}

export default TechnologySection;
